import { gql } from "graphql-tag";

export const findReviewsForBook = gql`
  query FindReviewsForBook(
    $filter: user_books_bool_exp!
    $userId: Int
    $includeCurrentUser: Boolean!
  ) {
    reviews: user_books(
      limit: 100
      where: $filter
      order_by: { likes_count: desc }
    ) {
      ...UserBookFullFragment
      user {
        ...UserBylineFragment
      }

      currentUserLike: likes(limit: 1, where: { user_id: { _eq: $userId } })
        @include(if: $includeCurrentUser) {
        ...LikeFragment
      }
      likes(limit: 5, order_by: { created_at: desc }) {
        ...LikeFragment
        user {
          ...UserBylineFragment
        }
      }
    }
  }
`;
